import {useOutletContext} from "react-router-dom";
import {SidebarPanelLayout} from "base/layout";
import Typography from "@mui/material/Typography";

const ConexionesHelpPanel = ({isSaneamiento}) => {
    const outletContext = useOutletContext();
    const setSidebarPanelOpen = outletContext[outletContext.length - 1];

    return (
        <SidebarPanelLayout
            sidebarTitle="Xestionar conexións"
            closeSidebarClick={() => setSidebarPanelOpen(false)}
        >
            <Typography>
                {isSaneamiento
                    ? "Preme unha EDAR ou un núcleo no mapa para consultar as súas conexións. Na EDAR podes xestionar as conexións entrantes e no núcleo as entrantes / saíntes."
                    : "Preme un elemento no mapa para consultar e xestionar as súas conexións."}
            </Typography>
        </SidebarPanelLayout>
    );
};

export default ConexionesHelpPanel;
